import { isNumber } from '@cutwise/utils';

import { IconName } from '@/common/components/Icon/iconName';

export const DEVIATION_0 = 0;
export const DEVIATION_90 = 90;
export const DEVIATION_115 = 115;
export const DEVIATION_180 = 180;
export const DEVIATION_245 = 245;
export const DEVIATION_270 = 270;

export const AMPLITUDE_SECTOR = 18;
export const AMPLITUDE_25 = 25;
export const AMPLITUDE_360 = 0;

export enum PlayerPositionViewType {
  All = 'all',
  Crown = 'crown',
  Disabled = 'disabled',
}

export class PlayerPositionViewModel {
  deviation!: number;
  amplitude!: number;
}

class PlayerPositionView extends PlayerPositionViewModel {
  constructor(deviation = DEVIATION_0, amplitude = AMPLITUDE_360) {
    super();

    if (isNumber(deviation)) {
      this.deviation = deviation!;
    }

    if (isNumber(amplitude)) {
      this.amplitude = amplitude!;
    }
  }

  get id() {
    return `${this.deviation}${this.amplitude}`;
  }

  get isCrown() {
    return this.deviation === PLAYER_CROWN_VIEW.deviation && this.amplitude === PLAYER_CROWN_VIEW.amplitude;
  }

  get isPavilion() {
    return this.deviation === PLAYER_PAVILION_VIEW.deviation && this.amplitude === PLAYER_PAVILION_VIEW.amplitude;
  }

  get isLeft() {
    return this.deviation === PLAYER_LEFT_VIEW.deviation && this.amplitude === PLAYER_LEFT_VIEW.amplitude;
  }

  get isRight() {
    return this.deviation === PLAYER_RIGHT_VIEW.deviation && this.amplitude === PLAYER_RIGHT_VIEW.amplitude;
  }

  get is360() {
    return this.deviation === PLAYER_360_VIEW.deviation && this.amplitude === PLAYER_360_VIEW.amplitude;
  }

  get title() {
    if (this.isPavilion) {
      return 'Pavilion';
    }

    if (this.isRight) {
      return 'Right';
    }

    if (this.isLeft) {
      return 'Left';
    }

    if (this.is360) {
      return '360';
    }

    return 'Crown';
  }

  get icon(): IconName {
    if (this.isPavilion) {
      return '4v-pavillion';
    }

    if (this.isRight) {
      return '4v-right';
    }

    if (this.isLeft) {
      return '4v-left';
    }

    if (this.is360) {
      return '4v-360';
    }

    return '4v-crown';
  }
}

export const PLAYER_CROWN_VIEW = new PlayerPositionView(DEVIATION_0, AMPLITUDE_SECTOR);
export const PLAYER_PAVILION_VIEW = new PlayerPositionView(DEVIATION_180, AMPLITUDE_SECTOR);
export const PLAYER_LEFT_VIEW = new PlayerPositionView(DEVIATION_115, AMPLITUDE_25);
export const PLAYER_RIGHT_VIEW = new PlayerPositionView(DEVIATION_245, AMPLITUDE_25);
export const PLAYER_360_VIEW = new PlayerPositionView();

export default PlayerPositionView;
